import { render, staticRenderFns } from "./TabCompetition.vue?vue&type=template&id=0572196a&"
import script from "./TabCompetition.vue?vue&type=script&lang=js&"
export * from "./TabCompetition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports